import { createShapeId, useEditor } from "@tldraw/tldraw"
import { useEffect } from "react"

function SavePng({ supabase }) {
    const editor = useEditor();

    // Returns the number of images already in the bucket
    const queryBucket = async () => {
        const { data, error } = await supabase
        .storage
        .from('sketches')
        .list("", {
            limit: 1,
            sortBy: { column: "created_at", order: "desc" }
        });
        if (error) {
            throw error
        }

        var number = Number(data[0].name.split("_")[1].split(".")[0]);

        return number;
    }

    // Uploads a file to the sketches bucket
    const uploadFile = async (file) => {
        var number = await queryBucket();
        number++;
        const { error: uploadError } = await supabase.storage.from('sketches').upload("sketch_" + number + ".png", file);
        if (uploadError) {
            throw uploadError;
        }
        else {
            window.location.href = "/post";
        }
    }

    // Converts a data URI to a file object
    const dataURIToFile = (dataURI, fileName) => {
        var arr = dataURI.split(',');
        var mime = arr[0].match(/:(.*?);/)[1];
        var bstr = atob(arr[1]);
        var n = bstr.length;
        var u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], fileName, {type: mime})
    }
    
    const handleClick = async () => {
        // Get all shapes on the canvas
        const allShapes = editor.store.allRecords().filter(r => r.typeName === 'shape');
        if (allShapes.length == 0) {
            alert("You must draw a frame before submitting.");
            return;
        }

        // Adjust for weird offset
        editor.nudgeShapes(allShapes, { x: -32, y: -32 });

        // Create a shape id
		const id = createShapeId("screenshot-helper");

        // Create a rectangle the size of the canvas
        editor.createShapes([
          {
            id,
            type: 'geo',
            x: 0,
            y: 0,
            opacity: 0,
            props: {
              geo: 'rectangle',
              w: 1280,
              h: 720
            }
          }
        ])

        // Get all the shapes on the canvas
        const shapes = editor.store.allRecords().filter(r => r.typeName === 'shape');

        // Convert to svg
        const svg = await editor.getSvg(shapes);

        // Serialize svg to string
        const svgString = (new XMLSerializer()).serializeToString(svg);

        // Convert string to blob
        const svgBlob = new Blob([svgString], {
            type: 'image/svg+xml;charset=utf-8'
        });

        // Create a url from the blob
        const DOMURL = window.URL || window.webkitURL || window;
        const url = DOMURL.createObjectURL(svgBlob);

        // Create an image from the url
        const image = new Image();
        image.width = 1280;
        image.height = 720;
        image.src = url;

        image.onload = () => {
            // Create a temporary canvas
            const canvas = document.createElement('canvas');
            canvas.width = image.width;
            canvas.height = image.height;
            const ctx = canvas.getContext('2d');

            // Add a white background
            ctx.fillStyle = 'white';
            ctx.fillRect(0,0,canvas.width,canvas.height);

            // Add the image
            ctx.drawImage(image, 0, 0);
            DOMURL.revokeObjectURL(url);

            // Create URI and download
            const imgURI = canvas
              .toDataURL('image/png')
              .replace('image/png', 'image/octet-stream');

            const file = dataURIToFile(imgURI, "file.png");
            uploadFile(file);
          };
    }
          

    return <button id="save-png" style={{display: "none"}} onClick={handleClick}></button>
}

export default SavePng